<template>
  <div class="container-fluid">
    <table class="xz-table">
      <thead>
      <tr>
        <th class="bold">Refusjon</th>
        <th class="bold">Antall</th>
        <th class="bold"></th>
        <th class="bold">Beløp</th>
      </tr>
      </thead>
      <tbody>

      <tr v-if="refundCashCount > 0">
        <td>Kontant</td>
        <td>{{refundCashCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(refundCashTotalAmount) }}</td>
      </tr>

      <tr v-if="refundCardCount > 0">
        <td>Kredittkort</td>
        <td>{{refundCardCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(refundCardTotalAmount) }}</td>
      </tr>

      <tr v-if="refundBankAxeptCount > 0">
        <td>BankAxept</td>
        <td>{{refundBankAxeptCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(refundBankAxeptTotalAmount) }}</td>
      </tr>

      <tr v-if="refundBonusCount > 0">
        <td>Bonuspoeng</td>
        <td>{{refundBonusCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(refundBonusTotalAmount) }}</td>
      </tr>

      <tr>
        <td class="bold">Total refusjon</td>
        <td class="bold">{{totalRefundCount}}</td>
        <td></td>
        <td class="bold">{{ displayTwoDecimals(xReportCounters.refundReceiptsTotalAmount) }}</td>
      </tr>

      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
  import MathUtil from "@/util/MathUtil";

  export default {
    props: {
      xReportCounters: Object,
      vat: Object
    },
    computed: {
      refundCashCount(){
        return this.xReportCounters.refundCashCount || 0;
      },
      refundCashTotalAmount(){
        return this.xReportCounters.refundCashTotalAmount || 0;
      },
      refundCardCount(){
        return this.xReportCounters.refundCardCount || 0;
      },
      refundCardTotalAmount(){
        return this.xReportCounters.refundCardTotalAmount || 0;
      },
      refundBankAxeptCount(){
        return this.xReportCounters.refundBankAxeptCount || 0;
      },
      refundBankAxeptTotalAmount(){
        return this.xReportCounters.refundBankAxeptTotalAmount || 0;
      },
      refundBonusCount(){
        return this.xReportCounters.refundBonusCount || 0;
      },
      refundBonusTotalAmount(){
        return this.xReportCounters.refundBonusTotalAmount || 0;
      },
      /** The payments paid back, the rows above added up, as «Total salg» counts payments: one refund paid back in
       *  cash and by card is 2 here (founder, 2026-10-29). How many returns there were is «Returkvitteringer». A
       *  report without the split by payment has only the number of returns. */
      totalRefundCount(){
        const split = this.xReportCounters.refundCashCount !== undefined || this.xReportCounters.refundCardCount !== undefined;
        if(!split){
          return this.xReportCounters.refundReceiptsCount || 0;
        }
        return this.refundCashCount + this.refundCardCount + this.refundBankAxeptCount + this.refundBonusCount;
      }
    },
    methods: {
      displayTwoDecimals(num){
        if(num > 0 || num < 0){
          return MathUtil.displayTwoDecimals(num);
        }else {
          return num;
        }
      }
    }
  }
</script>
